module.exports = __webpack_public_path__ + "static/media/btn_strava_connectwith_orange.aa0d255c.svg";